// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "TagCreateDto" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { TagType } from "./tag-type.enum.gen";

export const TagCreateDtoGenShape = z.strictObject({
  libraryId: z.string(),
  tagType: z.enum(TagType),
  name: z.string(),
  description: z.string(),
  order: z.number(),
  groupId: z.string().optional(),
  keywords: z.string(),
});
